/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CrudSystemActionType = {
    Manage: 'manage',
    Write: 'write',
    Read: 'read',
    Delete: 'delete'
} as const;
export type CrudSystemActionType = typeof CrudSystemActionType[keyof typeof CrudSystemActionType];


export function instanceOfCrudSystemActionType(value: any): boolean {
    for (const key in CrudSystemActionType) {
        if (Object.prototype.hasOwnProperty.call(CrudSystemActionType, key)) {
            if (CrudSystemActionType[key as keyof typeof CrudSystemActionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CrudSystemActionTypeFromJSON(json: any): CrudSystemActionType {
    return CrudSystemActionTypeFromJSONTyped(json, false);
}

export function CrudSystemActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrudSystemActionType {
    return json as CrudSystemActionType;
}

export function CrudSystemActionTypeToJSON(value?: CrudSystemActionType | null): any {
    return value as any;
}

export function CrudSystemActionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CrudSystemActionType {
    return value as CrudSystemActionType;
}

